import React, { useState, useEffect } from 'react';
import { string, func, number, oneOfType, bool } from 'prop-types';
import { replace, isEmpty, filter, includes, map, flatten } from 'lodash';
import SalesChannelSelect from './SalesChannelSelect';
import SpaceBetween from '../SpaceBetween';
import CompanyGroupsSelect from './CompanyGroupsSelect';
import { useReset } from '../../../utils/misc';
import { If } from '../../shared';
import Loading from '../Loading';

const SalesChannelByCompanySelect = ({
    width,
    onChangeSalesChannels,
    multiple,
    allSelected,
    fromResume,
    withoutStoreKind
}) => {
    const [companyGroup, setCompanyGroup] = useState({ label: 'Jumbo', value: 'Jumbo' });
    const [loadingSalesChannelSelect, setLoadingSalesChannelSelect] = useState(false);

    useEffect(() => {
        if (allSelected) return useReset(setLoadingSalesChannelSelect);
    }, [companyGroup]);

    const salesChannelSelectProps = { multiple, allSelected, fromResume };

    const fullWidth = width === '100%';
    const spaceBetweenWidth = fullWidth ? 0 : 13;
    const salesChannelFilteredOptions = options => filter(options, ({ kind }) => includes(companyGroup, kind));

    return (
        <>
            <If
                condition={!withoutStoreKind}
                then={
                    <>
                        <CompanyGroupsSelect
                            width={width}
                            multiple={multiple}
                            onChange={(value) => {
                                if (multiple) {
                                    const kinds = map(flatten([value]), 'value');
                                    return setCompanyGroup(kinds)
                                }
                                return setCompanyGroup(value);
                            }}
                            initialValue={{ label: 'Jumbo', value: 'Jumbo' }}
                        />
                        <SpaceBetween width={spaceBetweenWidth} />
                    </>
                }
            />
            <If
                condition={!loadingSalesChannelSelect}
                then={
                    <SalesChannelSelect
                        native
                        label='Tienda'
                        style={{ width: `${parseInt(replace(width, '%', '')) * 2}%` }}
                        {...salesChannelSelectProps}
                        onChange={(values) => onChangeSalesChannels(values)}
                        customizeOptions={options => {
                            if (isEmpty(companyGroup) || withoutStoreKind) return options;
                            return salesChannelFilteredOptions(options);
                        }}
                    />
                }
                else={<Loading loading />}
            />
        </>
    );
};

SalesChannelByCompanySelect.propTypes = {
    width: oneOfType([number, string]),
    onChangeSalesChannels: func,
    multiple: bool,
    allSelected: bool,
    fromResume: bool,
    withoutStoreKind: bool
};

SalesChannelByCompanySelect.defaultProps = {
    onChangeSalesChannels: () => {},
    withoutStoreKind: false
};

export default SalesChannelByCompanySelect;
